import { render, staticRenderFns } from "./ProvidersReferrals.vue?vue&type=template&id=093b0b38&scoped=true&"
import script from "./ProvidersReferrals.vue?vue&type=script&lang=js&"
export * from "./ProvidersReferrals.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersReferrals.vue?vue&type=style&index=0&id=093b0b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093b0b38",
  null
  
)

export default component.exports